export class SettingsAPI {
  constructor(cache, token, API) {
    this.cache = cache;
    this.token = token;
    this.API = API;
  }

  async saveProfile(data) {
    const res = await fetch(`${this.API}/api/user/profile`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.token}` },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to save profile.');
    
    // Removed cache.invalidate - refresh is called in component
    return res.json();
  }

  async saveNotifications(data) {
    const res = await fetch(`${this.API}/api/user/notifications`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${this.token}` },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed to save notification preferences.');
    
    // Removed cache.invalidate
    return res.json();
  }

  async disconnectSite(siteId) {
    const res = await fetch(`${this.API}/api/sites/${siteId}`, { 
      method: 'DELETE', 
      headers: { Authorization: `Bearer ${this.token}` } 
    });
    if (!res.ok) throw new Error('Failed to disconnect site.');
    
    // Handle empty response (204 No Content) or check if there's content
    if (res.status === 204 || res.headers.get('content-length') === '0') {
      return { success: true }; // Return a success object instead
    }
    
    // Only parse JSON if there's a body
    const text = await res.text();
    return text ? JSON.parse(text) : { success: true };
  }

  async startGaOAuth() {
    await new Promise(resolve => setTimeout(resolve, 2000));
    // Removed cache.invalidate
    return { success: true };
  }
}